import { useMutation, useQueryClient } from '@tanstack/react-query';
import tourConsentsApi from '@/features/dashboard/tourConsents/api/tourConsentsApi.ts';
import { toast } from 'sonner';
import { tourConsentsApiQueryKeys } from '@/features/dashboard/tourConsents/api/tourConsentsApi.queryKeys.ts';
import { CreateTourConsentDto } from '@/features/dashboard/tourConsents/types/TourConsentDto.ts';

export default function useCreateTourConsent(tourId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CreateTourConsentDto) => tourConsentsApi.create(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tourConsentsApiQueryKeys.byTourId(tourId),
      });
      toast.success('Zgoda została dodana');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description: error.message || 'Wystąpił błąd podczas dodawania zgody.',
      });
    },
  });
}
